(self["webpackChunkheyholy_ss_theme"] = self["webpackChunkheyholy_ss_theme"] || []).push([["/assets/new-product-section"],{

/***/ "./src/assets/js/quiz-components-v2/new-product-section.js":
/*!*****************************************************************!*\
  !*** ./src/assets/js/quiz-components-v2/new-product-section.js ***!
  \*****************************************************************/
/***/ (() => {

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _regeneratorValues(e) { if (null != e) { var t = e["function" == typeof Symbol && Symbol.iterator || "@@iterator"], r = 0; if (t) return t.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) return { next: function next() { return e && r >= e.length && (e = void 0), { value: e && e[r++], done: !e }; } }; } throw new TypeError(_typeof(e) + " is not iterable"); }
function _toArray(r) { return _arrayWithHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t["return"] || t["return"](); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { if (r) i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n;else { var o = function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); }; o("next", 0), o("throw", 1), o("return", 2); } }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _wrapNativeSuper(t) { var r = "function" == typeof Map ? new Map() : void 0; return _wrapNativeSuper = function _wrapNativeSuper(t) { if (null === t || !_isNativeFunction(t)) return t; if ("function" != typeof t) throw new TypeError("Super expression must either be null or a function"); if (void 0 !== r) { if (r.has(t)) return r.get(t); r.set(t, Wrapper); } function Wrapper() { return _construct(t, arguments, _getPrototypeOf(this).constructor); } return Wrapper.prototype = Object.create(t.prototype, { constructor: { value: Wrapper, enumerable: !1, writable: !0, configurable: !0 } }), _setPrototypeOf(Wrapper, t); }, _wrapNativeSuper(t); }
function _construct(t, e, r) { if (_isNativeReflectConstruct()) return Reflect.construct.apply(null, arguments); var o = [null]; o.push.apply(o, e); var p = new (t.bind.apply(t, o))(); return r && _setPrototypeOf(p, r.prototype), p; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _isNativeFunction(t) { try { return -1 !== Function.toString.call(t).indexOf("[native code]"); } catch (n) { return "function" == typeof t; } }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
// new-product-section.js - Quiz product recommendation and cart management
var NewProductSection = /*#__PURE__*/function (_HTMLElement) {
  function NewProductSection() {
    var _this;
    _classCallCheck(this, NewProductSection);
    _this = _callSuper(this, NewProductSection);
    _this.products = []; // Array of {handle, quantity, type, ...}
    _this.productData = new Map(); // Shopify product data cache
    _this.isLoading = false;
    _this.initialized = false; // Prevent double initialization
    _this.listenersSetup = false; // Prevent duplicate event listeners
    _this.deliveryInterval = parseInt(_this.dataset.frequency) || 4; // weeks
    _this.quizCompleteHandler = null; // Store event handler reference
    _this.recommendationProduct = null; // Store recommendation product data
    _this.defaultDog = _this.dataset.defaultDog;
    _this.upsellPriceType = _this.dataset.upsellPriceType || 'price_per_day'; // 'price_per_day' or 'default_price'
    _this.checkoutMode = (_this.dataset.checkoutMode || 'cart').toLowerCase();
    _this.discountStorageKey = 'quiz_discount_code';

    // Translations from data attributes
    _this.translations = {
      stuk: _this.dataset.stukText || 'Stück',
      pricePerKg: _this.dataset.pricePerKgText || 'Preis/Kg:',
      perDay: _this.dataset.perDayText || '/Tag',
      perMeal: _this.dataset.perMealText || 'pro Mahlzeit'
    };

    // Named event listeners so we can remove them later
    _this._onClick = _this._onClick.bind(_this);
    _this._onAddToCartClick = _this._onAddToCartClick.bind(_this);

    // Promise lock to avoid concurrent init runs
    _this._initPromise = null;
    return _this;
  }
  _inherits(NewProductSection, _HTMLElement);
  return _createClass(NewProductSection, [{
    key: "connectedCallback",
    value: function connectedCallback() {
      var _this2 = this;
      // Prevent double initialization - set flag IMMEDIATELY
      if (this.initialized || this.isLoading) {
        return;
      }

      // Set loading flag immediately to prevent race conditions
      this.isLoading = true;

      // Remove previous listener if any (safety)
      if (this.quizCompleteHandler) {
        document.removeEventListener('quiz:calculationsComplete', this.quizCompleteHandler);
      }

      // Create bound handler
      this.quizCompleteHandler = function () {
        // Call init() but rely on internal locking to avoid double runs
        _this2.init()["catch"](function (err) {
          return console.error('init error:', err);
        });
      };

      // Listen for quiz calculations complete event (no once; we manage removal)
      document.addEventListener('quiz:calculationsComplete', this.quizCompleteHandler);

      // If URL contains ?q= param, quiz-container will write fresh state to localStorage
      // and dispatch quiz:calculationsComplete. Skip eager init to avoid using stale data.
      var hasUrlParam = new URLSearchParams(window.location.search).has('q');

      // Try to initialize immediately if data already exists AND no URL restore is pending
      var quizData = JSON.parse(localStorage.getItem('quiz') || '{}');
      if (!hasUrlParam && quizData.dailyFoodCalculation && window.PACKED_PRODUCTS) {
        // Remove event listener since we don't need it
        document.removeEventListener('quiz:calculationsComplete', this.quizCompleteHandler);
        // Fire init but rely on lock so duplicate calls are safe
        this.init()["catch"](function (err) {
          return console.error('init error:', err);
        });
      } else {
        if (!hasUrlParam) {
          console.log('NewProductSection: Waiting for quiz calculations to complete...');
        }
        // Reset loading flag if waiting for event
        this.isLoading = false;
      }
    }
  }, {
    key: "disconnectedCallback",
    value: function disconnectedCallback() {
      // Clean up event listener when component is removed
      if (this.quizCompleteHandler) {
        document.removeEventListener('quiz:calculationsComplete', this.quizCompleteHandler);
        this.quizCompleteHandler = null;
      }

      // Remove DOM listeners we added
      this.removeEventListener('click', this._onClick);
      var addToCartBtn = document.querySelector('.primary--btn-buy, .add-to-cart-btn');
      if (addToCartBtn) {
        addToCartBtn.removeEventListener('click', this._onAddToCartClick);
      }
      this.listenersSetup = false;
    }
  }, {
    key: "init",
    value: function () {
      var _init = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
        var _this3 = this;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.n) {
            case 0:
              if (!this._initPromise) {
                _context2.n = 1;
                break;
              }
              return _context2.a(2, this._initPromise);
            case 1:
              this._initPromise = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
                var dataLoaded;
                return _regenerator().w(function (_context) {
                  while (1) switch (_context.n) {
                    case 0:
                      if (!_this3.initialized) {
                        _context.n = 1;
                        break;
                      }
                      _this3.isLoading = false;
                      _this3._initPromise = null;
                      return _context.a(2);
                    case 1:
                      // Set initialized flag IMMEDIATELY before any async operations
                      _this3.initialized = true;
                      _this3.isLoading = true;

                      // Dispatch loading start event
                      document.dispatchEvent(new CustomEvent('newProductSection:loadingStart'));

                      // Load quiz data and calculate products
                      dataLoaded = _this3.loadQuizData(); // Check if loadQuizData was successful
                      if (!(!dataLoaded || !_this3.dailyFoodCalculation)) {
                        _context.n = 2;
                        break;
                      }
                      console.error('NewProductSection: Failed to load quiz data, aborting');
                      document.dispatchEvent(new CustomEvent('newProductSection:loadingComplete'));
                      _this3.isLoading = false;
                      _this3.initialized = false; // Reset if failed
                      _this3._initPromise = null;
                      return _context.a(2);
                    case 2:
                      _context.n = 3;
                      return _this3.calculateProducts();
                    case 3:
                      // Deduplicate products by handle as extra safety
                      _this3._dedupeProductsByHandle();

                      // Load recommendation product from DOM if exists
                      _this3.loadRecommendationProduct();
                      _context.n = 4;
                      return _this3.renderProducts();
                    case 4:
                      // Setup event listeners only once
                      if (!_this3.listenersSetup) {
                        _this3.setupEventListeners();
                        _this3.listenersSetup = true;
                      }

                      // Calculate and display total price
                      _context.n = 5;
                      return _this3.updateTotalPrice();
                    case 5:
                      _context.n = 6;
                      return _this3.saveProductQuantitiesToLocalStorage();
                    case 6:
                      // Mark as completed
                      _this3.isLoading = false;

                      // Dispatch loading complete event
                      document.dispatchEvent(new CustomEvent('newProductSection:loadingComplete'));
                      console.log('NewProductSection: Initialization complete');

                      // Dispatch dominant food type for review slider
                      _this3._dispatchDominantFoodResolved();

                      // Clear lock
                      _this3._initPromise = null;
                    case 7:
                      return _context.a(2);
                  }
                }, _callee);
              }))();
              return _context2.a(2, this._initPromise);
          }
        }, _callee2, this);
      }));
      function init() {
        return _init.apply(this, arguments);
      }
      return init;
    }()
    /**
     * Remove duplicates in this.products keeping first occurrence
     */
  }, {
    key: "_dedupeProductsByHandle",
    value: function _dedupeProductsByHandle() {
      var seen = new Set();
      var deduped = [];
      var _iterator = _createForOfIteratorHelper(this.products),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var p = _step.value;
          if (!seen.has(p.handle)) {
            deduped.push(p);
            seen.add(p.handle);
          } else {
            console.warn('Duplicate product handle removed during dedupe:', p.handle);
          }
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
      this.products = deduped;
    }

    /**
     * Determine dominant food type (dry vs wet by totalGrams) and dispatch event
     * for quiz-review-slider to pick the right product's reviews
     */
  }, {
    key: "_dispatchDominantFoodResolved",
    value: function _dispatchDominantFoodResolved() {
      var _this$dailyFoodCalcul, _window$PACKED_PRODUC, _group$dominantType;
      var groupKey = ((_this$dailyFoodCalcul = this.dailyFoodCalculation) === null || _this$dailyFoodCalcul === void 0 ? void 0 : _this$dailyFoodCalcul.groupKey) || 'hunters';
      var group = (_window$PACKED_PRODUC = window.PACKED_PRODUCTS) === null || _window$PACKED_PRODUC === void 0 ? void 0 : _window$PACKED_PRODUC.groups[groupKey];
      if (!group) return;
      var dryGrams = 0;
      var wetGrams = 0;
      var _iterator2 = _createForOfIteratorHelper(this.products),
        _step2;
      try {
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          var p = _step2.value;
          if (p.type === 'dry') dryGrams += p.totalGrams || 0;
          if (p.type === 'wet') wetGrams += p.totalGrams || 0;
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }
      var dominantType = wetGrams > dryGrams ? 'wet' : 'dry';
      var handle = (_group$dominantType = group[dominantType]) === null || _group$dominantType === void 0 ? void 0 : _group$dominantType.handle;
      if (!handle) return;
      console.log("[DominantFood] type=".concat(dominantType, ", handle=").concat(handle, ", dry=").concat(dryGrams, "g, wet=").concat(wetGrams, "g"));
      document.dispatchEvent(new CustomEvent('quiz:dominantFoodResolved', {
        detail: {
          handle: handle,
          dominantType: dominantType,
          groupKey: groupKey
        }
      }));
    }

    /**
     * Load recommendation product from DOM if exists
     */
  }, {
    key: "loadRecommendationProduct",
    value: function loadRecommendationProduct() {
      var recCard = document.querySelector('.recommendation-product');
      var recText = document.querySelector('.recommendation-text');
      if (!recCard) {
        console.log('No recommendation product found in DOM');
        // Hide recommendation text if no product
        if (recText) {
          recText.style.display = 'none';
        }
        return;
      }
      var deletedProducts = this.getDeletedProducts();
      var handle = recCard.dataset.handle;
      if (deletedProducts.includes(handle)) {
        console.log("Recommendation product ".concat(handle, " was deleted, removing from DOM"));
        recCard.remove();
        // Hide recommendation text when product is deleted
        if (recText) {
          recText.style.display = 'none';
        }
        return;
      }

      // Extract quantity from DOM
      var qtyEl = recCard.querySelector('.quantity-value');
      var quantity = qtyEl ? parseInt(qtyEl.textContent) || 1 : 1;
      this.recommendationProduct = {
        handle: handle,
        sku: recCard.dataset.sku || null,
        quantity: quantity,
        type: recCard.dataset.type || 'recommendation',
        isRecommendation: true
      };

      // Set initial disabled state for minus button if quantity is 1
      var minusBtn = recCard.querySelector('.quantity-btn--minus');
      if (minusBtn && quantity <= 1) {
        minusBtn.disabled = true;
        minusBtn.classList.add('disabled');
      }

      // Show recommendation text if product exists
      if (recText) {
        recText.style.display = 'block';
      }
    }

    /**
     * Load quiz data from localStorage
     * @returns {boolean} True if data loaded successfully
     */
  }, {
    key: "loadQuizData",
    value: function loadQuizData() {
      var quizData = JSON.parse(localStorage.getItem('quiz') || '{}');
      if (!quizData.dailyFoodCalculation) {
        console.error('No daily food calculation found in quiz data');
        return false;
      }
      this.quizData = quizData;
      this.dailyFoodCalculation = quizData.dailyFoodCalculation;
      return true;
    }

    /**
     * Calculate food composition from multiple-choice checkboxes
     * Replaces slider-based ratio selection
     *
     * Rules:
     * - Trockenfutter only → 100% dry / 0% wet
     * - Nassfutter only → 100% wet
     * - BARF only → 100% wet
     * - Trockenfutter + any wet option(s) → 50% dry / 50% wet
     * - Nassfutter + BARF (without Trockenfutter) → 100% wet
     *
     * Legacy fallback: supports old slider-based data for backward compatibility
     */
  }, {
    key: "getFoodComposition",
    value: function getFoodComposition() {
      var _quizData$checkboxSta, _quizData$twoSliderSt;
      var quizData = this.quizData || JSON.parse(localStorage.getItem('quiz') || '{}');
      var checkboxStates = (quizData === null || quizData === void 0 || (_quizData$checkboxSta = quizData.checkboxStates) === null || _quizData$checkboxSta === void 0 ? void 0 : _quizData$checkboxSta['entry.306846565']) || [];
      var isChecked = function isChecked(key) {
        return checkboxStates.some(function (item) {
          return (item.value === key || item.id === key) && item.checked === true;
        });
      };
      var hasDry = isChecked('trockenfutter');
      var hasWet = isChecked('nassfutter');
      var hasBarf = isChecked('barf');
      var hasAnyWet = hasWet || hasBarf;

      // Trockenfutter only → 100% dry food
      if (hasDry && !hasAnyWet) {
        return {
          dryPercent: 100,
          wetPercent: 0
        };
      }

      // Trockenfutter + any wet option → 50/50 split
      if (hasDry && hasAnyWet) {
        return {
          dryPercent: 50,
          wetPercent: 50
        };
      }

      // Only wet food (Nassfutter and/or BARF) → 100% wet
      if (!hasDry && hasAnyWet) {
        return {
          dryPercent: 0,
          wetPercent: 100
        };
      }

      // Legacy fallback for old slider-based data
      var legacy = (_quizData$twoSliderSt = quizData.twoSliderStates) === null || _quizData$twoSliderSt === void 0 ? void 0 : _quizData$twoSliderSt['food-composition'];
      if (legacy) {
        return {
          dryPercent: legacy.Trockenfutter || 0,
          wetPercent: legacy.Nassfutter || 0
        };
      }

      // Default fallback (should not occur in normal flow)
      return {
        dryPercent: 50,
        wetPercent: 50
      };
    }

    /**
     * Calculate which products and quantities needed based on checkbox selection
     *
     * Uses multiple-choice food type logic (not slider):
     * - Calculates dry/wet ratio from checkboxes
     * - Applies 30% rule for package quantities
     * - Limits 18-pack wet food to 1 unit when dry food >= 50%
     */
  }, {
    key: "calculateProducts",
    value: (function () {
      var _calculateProducts = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3() {
        var days, groupKey, group, dailyDry, dailyWet, snacksPerDay, foodComposition, dryPercent, wetPercent, shouldLimit18Pack, totalWetNeeded, wetData, wetVariant, wetProduct, is18Pack, wetGramsPerPack, wetQuantity, _group$dry$variants, totalDryNeeded, shouldUseSoftFood, dryProduct, softVariant, softQuantity, totalSnacksNeeded, snackProduct, snackPacks;
        return _regenerator().w(function (_context3) {
          while (1) switch (_context3.n) {
            case 0:
              days = 28;
              groupKey = this.dailyFoodCalculation.groupKey || 'hunters';
              group = window.PACKED_PRODUCTS.groups[groupKey];
              if (group) {
                _context3.n = 1;
                break;
              }
              console.error('Group not found:', groupKey);
              return _context3.a(2);
            case 1:
              this.products = [];
              dailyDry = this.dailyFoodCalculation.dailyDryGrams;
              dailyWet = this.dailyFoodCalculation.dailyWetGrams;
              snacksPerDay = this.dailyFoodCalculation.snacksPerDay || 0; // Get food composition from checkboxes
              foodComposition = this.getFoodComposition();
              dryPercent = foodComposition.dryPercent;
              wetPercent = foodComposition.wetPercent; // Apply 18-pack limit rule when dry food is 50% or more
              shouldLimit18Pack = dryPercent >= 50;
              if (wetPercent > 0 && dailyWet > 0) {
                totalWetNeeded = dailyWet * days;
                wetData = group.wet;
                if (group.wet.huhn && group.wet.forelle) {
                  wetVariant = group.wet["default"] || 'huhn';
                  wetData = group.wet[wetVariant];
                }

                // Check if wet food has variants (6x vs 18x packs)
                if (wetData.variants) {
                  wetProduct = this.calculateOptimalVariant(wetData, totalWetNeeded);
                  if (wetProduct) {
                    // Check if dry food is 50% or more and the selected variant is an 18-pack
                    is18Pack = this.is18PackVariant(wetData.variants, wetProduct.sku);
                    if (shouldLimit18Pack && is18Pack && wetProduct.quantity > 1) {
                      wetProduct.quantity = 1;
                      wetProduct.totalGrams = wetProduct.gramsPerUnit;
                    }
                    this.products.push({
                      handle: wetData.handle,
                      sku: wetProduct.sku,
                      quantity: wetProduct.quantity,
                      type: 'wet',
                      gramsPerUnit: wetProduct.gramsPerUnit,
                      totalGrams: wetProduct.totalGrams
                    });
                  }
                } else {
                  // Fallback for groups without wet variants
                  wetGramsPerPack = wetData.gramsPerPack;
                  wetQuantity = this.calculatePackQuantity(totalWetNeeded, wetGramsPerPack);
                  if (wetQuantity > 0) {
                    this.products.push({
                      handle: wetData.handle,
                      sku: wetData.sku,
                      quantity: wetQuantity,
                      type: 'wet',
                      gramsPerUnit: wetGramsPerPack,
                      totalGrams: wetQuantity * wetGramsPerPack
                    });
                  }
                }
              }
              if (dryPercent > 0 && dailyDry > 0) {
                totalDryNeeded = dailyDry * days; // For minis with small weight (< 3kg daily need), prefer soft food variant (SKU 40024)
                // Otherwise use calculateOptimalVariant which will choose best option
                shouldUseSoftFood = groupKey === 'minis' && totalDryNeeded < 3000 * days && ((_group$dry$variants = group.dry.variants) === null || _group$dry$variants === void 0 ? void 0 : _group$dry$variants.soft);
                if (shouldUseSoftFood) {
                  // Use soft food variant (SKU 40024) for very small minis
                  softVariant = group.dry.variants.soft;
                  softQuantity = this.calculatePackQuantity(totalDryNeeded, softVariant.grams);
                  dryProduct = {
                    sku: softVariant.sku,
                    quantity: softQuantity,
                    gramsPerUnit: softVariant.grams,
                    totalGrams: softQuantity * softVariant.grams
                  };
                } else {
                  dryProduct = this.calculateOptimalVariant(group.dry, totalDryNeeded);
                }
                if (dryProduct) {
                  this.products.push({
                    handle: group.dry.handle,
                    sku: dryProduct.sku,
                    quantity: dryProduct.quantity,
                    type: 'dry',
                    gramsPerUnit: dryProduct.gramsPerUnit,
                    totalGrams: dryProduct.totalGrams
                  });
                } else {
                  console.error('Failed to calculate dry product for', groupKey, '- dryProduct is null');
                }
              }
              if (snacksPerDay > 0) {
                if (!group.snacks) {
                  console.error('Snacks requested but snacks configuration not found in group:', groupKey);
                } else {
                  // Calculate total snacks needed for delivery period
                  totalSnacksNeeded = snacksPerDay * days * group.snacks.gramsPerPiece;
                  if (group.snacks.variants) {
                    snackProduct = this.calculateOptimalVariant(group.snacks, totalSnacksNeeded);
                    if (snackProduct) {
                      this.products.push({
                        handle: group.snacks.handle,
                        sku: snackProduct.sku,
                        quantity: snackProduct.quantity,
                        type: 'snacks',
                        gramsPerUnit: snackProduct.gramsPerUnit,
                        totalGrams: snackProduct.totalGrams
                      });
                    } else {
                      console.warn('Snacks calculation returned no product for variants');
                    }
                  } else {
                    // Fallback for groups without snacks variants
                    snackPacks = snacksPerDay <= 10 ? 1 : 2;
                    this.products.push({
                      handle: group.snacks.handle,
                      sku: group.snacks.sku,
                      quantity: snackPacks,
                      type: 'snacks',
                      gramsPerUnit: group.snacks.gramsPerPack,
                      totalGrams: snackPacks * group.snacks.gramsPerPack
                    });
                    console.log('Snacks added (fallback):', {
                      handle: group.snacks.handle,
                      sku: group.snacks.sku,
                      quantity: snackPacks,
                      snacksPerDay: snacksPerDay
                    });
                  }
                }
              }
              console.log('=== CALCULATE PRODUCTS END ===');
              console.log('Products array:', this.products);
              console.log('Total products:', this.products.length);
            case 2:
              return _context3.a(2);
          }
        }, _callee3, this);
      }));
      function calculateProducts() {
        return _calculateProducts.apply(this, arguments);
      }
      return calculateProducts;
    }()
    /**
     * Save product quantities and subscription interval to localStorage for GTM tracking
     * This method is called after loadRecommendationProduct() to ensure recommendation is included
     */
    )
  }, {
    key: "saveProductQuantitiesToLocalStorage",
    value: (function () {
      var _saveProductQuantitiesToLocalStorage = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4() {
        var quizData, productHandles, productSkus, productQuantities, productNames, productsArray, _iterator3, _step3, product, productData, productName, recHandle, recData, recProductData, recProductName, productSkuAmount, i, j, _t;
        return _regenerator().w(function (_context4) {
          while (1) switch (_context4.n) {
            case 0:
              _context4.p = 0;
              quizData = JSON.parse(localStorage.getItem('quiz') || '{}'); // Create arrays for proper product tracking
              productHandles = [];
              productSkus = [];
              productQuantities = [];
              productNames = [];
              productsArray = []; // Add main products
              _iterator3 = _createForOfIteratorHelper(this.products);
              try {
                for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
                  product = _step3.value;
                  productHandles.push(product.handle);
                  productSkus.push(product.sku || product.handle);
                  productQuantities.push(product.quantity);

                  // Get product name from productData if available
                  productData = this.productData.get(product.handle);
                  productName = (productData === null || productData === void 0 ? void 0 : productData.title) || product.handle;
                  productNames.push(productName);

                  // Create product object for products array
                  productsArray.push({
                    product_sku: product.sku || product.handle,
                    monthly_quantity: product.quantity
                  });
                }

                // Include recommendation product if it exists
              } catch (err) {
                _iterator3.e(err);
              } finally {
                _iterator3.f();
              }
              if (!this.recommendationProduct) {
                _context4.n = 3;
                break;
              }
              recHandle = this.recommendationProduct.handle; // Fetch product data if not cached (for title)
              if (this.productData.has(recHandle)) {
                _context4.n = 2;
                break;
              }
              _context4.n = 1;
              return this.fetchProductData(recHandle);
            case 1:
              recData = _context4.v;
              if (recData) {
                this.productData.set(recHandle, recData);
              }
            case 2:
              productHandles.push(recHandle);
              productSkus.push(this.recommendationProduct.sku || recHandle);
              productQuantities.push(this.recommendationProduct.quantity);

              // Get recommendation product name from productData if available
              recProductData = this.productData.get(recHandle);
              recProductName = (recProductData === null || recProductData === void 0 ? void 0 : recProductData.title) || recHandle;
              productNames.push(recProductName);

              // Add to products array
              productsArray.push({
                product_sku: this.recommendationProduct.sku || recHandle,
                monthly_quantity: this.recommendationProduct.quantity
              });
              console.log('Recommendation product added to tracking:', {
                handle: recHandle,
                sku: this.recommendationProduct.sku,
                quantity: this.recommendationProduct.quantity,
                name: recProductName
              });
              _context4.n = 4;
              break;
            case 3:
              console.log('No recommendation product to add to tracking');
            case 4:
              // Save to localStorage with proper structure
              quizData.productHandles = productHandles;
              quizData.productSkus = productSkus;
              quizData.productQuantities = productQuantities;
              quizData.productNames = productNames;
              quizData.productsArray = productsArray;
              quizData.subscriptionIntervallWeeks = this.deliveryInterval;

              // Keep legacy productSkuAmount for backward compatibility (repeated SKUs)
              productSkuAmount = [];
              for (i = 0; i < productSkus.length; i++) {
                for (j = 0; j < productQuantities[i]; j++) {
                  productSkuAmount.push(productSkus[i]);
                }
              }
              quizData.productSkuAmount = productSkuAmount;
              localStorage.setItem('quiz', JSON.stringify(quizData));
              _context4.n = 6;
              break;
            case 5:
              _context4.p = 5;
              _t = _context4.v;
              console.error('Error saving product quantities to localStorage:', _t);
            case 6:
              return _context4.a(2);
          }
        }, _callee4, this, [[0, 5]]);
      }));
      function saveProductQuantitiesToLocalStorage() {
        return _saveProductQuantitiesToLocalStorage.apply(this, arguments);
      }
      return saveProductQuantitiesToLocalStorage;
    }()
    /**
     * Calculate optimal variant for dry food (7kg vs 14kg)
     * Uses 30% rule: add extra bag only if remainder >= 30% of bag size
     */
    )
  }, {
    key: "calculateOptimalVariant",
    value: function calculateOptimalVariant(dryFood, totalGramsNeeded) {
      var variants = Object.values(dryFood.variants).sort(function (a, b) {
        return b.priority - a.priority;
      });
      var bestOption = null;
      var minUnits = Infinity;
      console.log('Calculating optimal variant for:', {
        totalGramsNeeded: totalGramsNeeded,
        variants: variants.map(function (v) {
          return {
            sku: v.sku,
            grams: v.grams
          };
        })
      });
      var _iterator4 = _createForOfIteratorHelper(variants),
        _step4;
      try {
        for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
          var variant = _step4.value;
          var fullBags = Math.floor(totalGramsNeeded / variant.grams);
          var remainder = totalGramsNeeded % variant.grams;
          var threshold = variant.grams * 0.3;
          var totalUnits = fullBags;
          if (remainder > 0 && remainder >= threshold) {
            totalUnits += 1;
          }
          if (totalUnits < minUnits && totalUnits > 0) {
            minUnits = totalUnits;
            bestOption = {
              sku: variant.sku,
              quantity: totalUnits,
              gramsPerUnit: variant.grams,
              totalGrams: totalUnits * variant.grams
            };
          }
        }
      } catch (err) {
        _iterator4.e(err);
      } finally {
        _iterator4.f();
      }
      return bestOption;
    }

    /**
     * Calculate pack quantity for wet food/snacks
     * Uses 30% rule
     */
  }, {
    key: "calculatePackQuantity",
    value: function calculatePackQuantity(totalGramsNeeded, gramsPerPack) {
      var fullPacks = Math.floor(totalGramsNeeded / gramsPerPack);
      var remainder = totalGramsNeeded % gramsPerPack;
      var threshold = gramsPerPack * 0.3;
      var extraPack = remainder >= threshold ? 1 : 0;
      var total = fullPacks + extraPack;
      return total;
    }

    /**
     * Calculate how many days a product lasts based on daily consumption
     * @param {Object} product - Product object with type and totalGrams
     * @returns {number} Number of days the product lasts
     */
  }, {
    key: "calculateDaysProductLasts",
    value: function calculateDaysProductLasts(product) {
      var _window$PACKED_PRODUC2, _group$snacks;
      var totalQuantity = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
      if (!this.dailyFoodCalculation) return 28;
      var _this$dailyFoodCalcul2 = this.dailyFoodCalculation,
        dailyDryGrams = _this$dailyFoodCalcul2.dailyDryGrams,
        dailyWetGrams = _this$dailyFoodCalcul2.dailyWetGrams,
        snacksPerDay = _this$dailyFoodCalcul2.snacksPerDay;
      // Используем общий вес всех упаковок данного типа в корзине
      var gramsPerUnit = product.gramsPerUnit || 0;
      var totalGrams = gramsPerUnit * totalQuantity;
      if (totalGrams <= 0) return 28;
      var dailyConsumption = 0;
      switch (product.type) {
        case 'dry':
          dailyConsumption = dailyDryGrams || 0;
          break;
        case 'wet':
          dailyConsumption = dailyWetGrams || 0;
          break;
        case 'snacks':
          var groupKey = this.dailyFoodCalculation.groupKey || 'hunters';
          var group = (_window$PACKED_PRODUC2 = window.PACKED_PRODUCTS) === null || _window$PACKED_PRODUC2 === void 0 ? void 0 : _window$PACKED_PRODUC2.groups[groupKey];
          var gramsPerPiece = (group === null || group === void 0 || (_group$snacks = group.snacks) === null || _group$snacks === void 0 ? void 0 : _group$snacks.gramsPerPiece) || 0.8;
          dailyConsumption = snacksPerDay * gramsPerPiece;
          break;
        default:
          return 28;
      }
      if (dailyConsumption <= 0) return 28;

      // Теперь считаем на сколько дней хватит ВСЕГО запаса этого товара
      var daysLasts = totalGrams / dailyConsumption;
      return Math.max(1, Math.round(daysLasts));
    }

    /**
     * Check if a variant is an 18-pack (largest pack size)
     * Used to enforce rule: max 1x 18-pack when dry food >= 50%
     *
     * 18-pack variants have the highest priority (10) in the variants object
     * This prevents over-recommendation of large wet food packs when dry food dominates
     */
  }, {
    key: "is18PackVariant",
    value: function is18PackVariant(variants, sku) {
      if (!variants || !sku) return false;

      // Find the variant with this SKU
      var variant = Object.values(variants).find(function (v) {
        return v.sku === sku;
      });
      if (!variant) return false;

      // 18-pack variants have priority 10 (highest)
      // This matches the configuration in quiz-products-final.js
      return variant.priority === 10;
    }

    /**
     * Fetch product data from Shopify and render cards
     */
  }, {
    key: "renderProducts",
    value: (function () {
      var _renderProducts = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee5() {
        var _this4 = this;
        var container, deletedProducts, handlesOrdered, seen, _iterator5, _step5, p, fetchPromises, fetched, fetchedMap, _iterator6, _step6, item, appendedHandles, appendedCount, _iterator7, _step7, product, productData, card, _t2, _t3;
        return _regenerator().w(function (_context5) {
          while (1) switch (_context5.n) {
            case 0:
              container = this.querySelector('.new-product-section__box-content');
              if (container) {
                _context5.n = 1;
                break;
              }
              console.error('Product container not found');
              return _context5.a(2);
            case 1:
              // Clear existing content to prevent duplicates
              container.innerHTML = '';

              // Load deleted products from localStorage
              deletedProducts = this.getDeletedProducts(); // Deduplicate handles and preserve order of this.products
              handlesOrdered = [];
              seen = new Set();
              _iterator5 = _createForOfIteratorHelper(this.products);
              _context5.p = 2;
              _iterator5.s();
            case 3:
              if ((_step5 = _iterator5.n()).done) {
                _context5.n = 6;
                break;
              }
              p = _step5.value;
              if (!deletedProducts.includes(p.handle)) {
                _context5.n = 4;
                break;
              }
              console.log("Product ".concat(p.handle, " was deleted, skipping"));
              return _context5.a(3, 5);
            case 4:
              if (!seen.has(p.handle)) {
                handlesOrdered.push(p.handle);
                seen.add(p.handle);
              }
            case 5:
              _context5.n = 3;
              break;
            case 6:
              _context5.n = 8;
              break;
            case 7:
              _context5.p = 7;
              _t2 = _context5.v;
              _iterator5.e(_t2);
            case 8:
              _context5.p = 8;
              _iterator5.f();
              return _context5.f(8);
            case 9:
              // Fetch product data in parallel (but we will append in product order)
              fetchPromises = handlesOrdered.map(function (handle) {
                return _this4.fetchProductData(handle).then(function (res) {
                  return {
                    handle: handle,
                    res: res
                  };
                }, function (err) {
                  return {
                    handle: handle,
                    res: null,
                    err: err
                  };
                });
              });
              _context5.n = 10;
              return Promise.all(fetchPromises);
            case 10:
              fetched = _context5.v;
              // Map fetched results to quick lookup
              fetchedMap = new Map();
              _iterator6 = _createForOfIteratorHelper(fetched);
              try {
                for (_iterator6.s(); !(_step6 = _iterator6.n()).done;) {
                  item = _step6.value;
                  if (item.res) {
                    fetchedMap.set(item.handle, item.res);
                    this.productData.set(item.handle, item.res);
                  } else {
                    console.error('Failed to fetch product:', item.handle, item.err || '');
                  }
                }

                // Append cards in the same order as this.products (first occurrence)
              } catch (err) {
                _iterator6.e(err);
              } finally {
                _iterator6.f();
              }
              appendedHandles = new Set();
              appendedCount = 0;
              _iterator7 = _createForOfIteratorHelper(this.products);
              _context5.p = 11;
              _iterator7.s();
            case 12:
              if ((_step7 = _iterator7.n()).done) {
                _context5.n = 17;
                break;
              }
              product = _step7.value;
              if (!appendedHandles.has(product.handle)) {
                _context5.n = 13;
                break;
              }
              return _context5.a(3, 16);
            case 13:
              if (!deletedProducts.includes(product.handle)) {
                _context5.n = 14;
                break;
              }
              return _context5.a(3, 16);
            case 14:
              productData = fetchedMap.get(product.handle);
              if (productData) {
                _context5.n = 15;
                break;
              }
              console.warn('No productData for handle:', product.handle);
              return _context5.a(3, 16);
            case 15:
              card = this.createProductCard(product, productData);
              container.appendChild(card);
              appendedHandles.add(product.handle);
              appendedCount++;
            case 16:
              _context5.n = 12;
              break;
            case 17:
              _context5.n = 19;
              break;
            case 18:
              _context5.p = 18;
              _t3 = _context5.v;
              _iterator7.e(_t3);
            case 19:
              _context5.p = 19;
              _iterator7.f();
              return _context5.f(19);
            case 20:
              return _context5.a(2);
          }
        }, _callee5, this, [[11, 18, 19, 20], [2, 7, 8, 9]]);
      }));
      function renderProducts() {
        return _renderProducts.apply(this, arguments);
      }
      return renderProducts;
    }()
    /**
     * Fetch product data from Shopify
     */
    )
  }, {
    key: "fetchProductData",
    value: (function () {
      var _fetchProductData = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee6(handle) {
        var response, _t4;
        return _regenerator().w(function (_context6) {
          while (1) switch (_context6.n) {
            case 0:
              _context6.p = 0;
              _context6.n = 1;
              return fetch("/products/".concat(handle, ".js"));
            case 1:
              response = _context6.v;
              if (response.ok) {
                _context6.n = 2;
                break;
              }
              throw new Error("HTTP ".concat(response.status));
            case 2:
              _context6.n = 3;
              return response.json();
            case 3:
              return _context6.a(2, _context6.v);
            case 4:
              _context6.p = 4;
              _t4 = _context6.v;
              console.error("Error fetching product ".concat(handle, ":"), _t4);
              return _context6.a(2, null);
          }
        }, _callee6, null, [[0, 4]]);
      }));
      function fetchProductData(_x) {
        return _fetchProductData.apply(this, arguments);
      }
      return fetchProductData;
    }())
  }, {
    key: "formatTotalWeight",
    value: function formatTotalWeight(quantity, gramsPerUnit) {
      var totalGrams = quantity * gramsPerUnit;
      var kg = totalGrams / 1000;
      return "".concat(kg % 1 === 0 ? kg : kg.toFixed(1), "kg");
    }
  }, {
    key: "getAlternativeImage",
    value: function getAlternativeImage(handle) {
      var discountData = this.getDiscountData();
      var item = discountData.find(function (i) {
        return i.handle === handle;
      });
      return (item === null || item === void 0 ? void 0 : item.alternative_image) || null;
    }

    /**
     * Create product card element
     */
  }, {
    key: "createProductCard",
    value: function createProductCard(product, productData) {
      var _productData$images;
      var card = document.createElement('div');
      card.className = 'product-card';
      card.dataset.handle = product.handle;
      card.dataset.type = product.type;

      // Find variant by SKU, fallback to first variant
      var variant = productData.variants.find(function (v) {
        return v.sku === product.sku;
      }) || productData.variants[0];

      // Store max quantity (inventory)
      var maxQuantity = variant.inventory_quantity || 99;
      card.dataset.maxQuantity = maxQuantity;
      card.dataset.grams = variant.grams || '';
      var alternativeImageFromJson = this.getAlternativeImage(product.handle);
      var image = alternativeImageFromJson || productData.images[0] || '';

      // Debug: log image sources
      console.log('[createProductCard] handle:', product.handle, {
        alternativeImageFromJson: alternativeImageFromJson,
        'productData.images[0]': productData.images[0],
        'productData.images.length': (_productData$images = productData.images) === null || _productData$images === void 0 ? void 0 : _productData$images.length,
        finalImage: image
      });

      // Calculate subscription prices
      var prices = this.calculateSubscriptionPrice(variant, productData);
      // Price per day is calculated based on single unit, not multiplied by quantity
      var singleUnitPrice = prices.discountedPrice;
      var pricePerUnit = this.getPricePerUnitInfo(product, variant, productData, prices.discountedPrice);

      // Calculate how many days ONE unit lasts (per-day must not depend on quantity)
      var daysLastsPerUnit = this.calculateDaysProductLasts({
        type: product.type,
        gramsPerUnit: product.gramsPerUnit || (variant === null || variant === void 0 ? void 0 : variant.grams) || 0,
        quantity: 1
      });
      var totalProductPrice = prices.discountedPrice * product.quantity;

      // Calculate price display based on upsellPriceType
      var priceDisplay;
      var pricePerDayValue;
      var comparePriceDisplay = '';
      if (this.upsellPriceType === 'default_price') {
        // Default price mode: show total price without day division
        priceDisplay = "\u20AC".concat(totalProductPrice.toFixed(2).replace('.', ','));
        pricePerDayValue = totalProductPrice; // Store total for data attribute

        // Calculate compare price if discount exists
        var totalOriginalPrice = prices.originalPrice * product.quantity;
        if (prices.hasDiscount && totalOriginalPrice > totalProductPrice) {
          comparePriceDisplay = "\u20AC".concat(totalOriginalPrice.toFixed(2).replace('.', ','));
        }
      } else {
        // Price per day mode (current behavior)
        var pricePerDay = this.calculatePricePerDay(singleUnitPrice, product.quantity, daysLastsPerUnit);
        priceDisplay = "\u20AC".concat(pricePerDay.toFixed(2).replace('.', ',')).concat(this.translations.perDay);
        pricePerDayValue = pricePerDay;

        // Calculate strike price per day if discount exists
        var _totalOriginalPrice = prices.originalPrice * product.quantity;
        var comparePricePerDay = prices.hasDiscount ? this.calculatePricePerDay(prices.originalPrice, product.quantity, daysLastsPerUnit) : 0;
        if (comparePricePerDay > 0) {
          comparePriceDisplay = "\u20AC".concat(comparePricePerDay.toFixed(2).replace('.', ','));
        }
      }
      if (prices.hasDiscount && comparePriceDisplay) {
        card.classList.add('discounted');
      }

      // Format: quantity x variant.title (e.g. "2x 18x400g")
      var formatQuantityDisplay = function formatQuantityDisplay() {
        var variantBySku = productData.variants.find(function (v) {
          return v.sku === product.sku;
        });
        var variantTitle = variantBySku ? variantBySku.title.trim() : variant.title.trim();
        return "".concat(variantTitle.replace(' ', ''));
      };
      card.innerHTML = "\n    <div class=\"tw-relative product-card__image-wrapper\">\n      <button \n        type=\"button\" \n        class=\"quantity-btn quantity-btn--minus".concat(product.quantity <= 1 ? ' disabled' : '', "\"\n        aria-label=\"Decrease quantity\"\n        ").concat(product.quantity <= 1 ? 'disabled' : '', "\n      >\n        <svg xmlns=\"http://www.w3.org/2000/svg\" width=\"6\" height=\"2\" viewBox=\"0 0 6 2\" fill=\"none\">\n          <path d=\"M0.600098 0.599609L4.6001 0.599609\" stroke=\"#1B1B1B\" stroke-width=\"1.2\" stroke-linecap=\"round\"/>\n        </svg>\n      </button>\n      \n      <div class=\"product-card__image\">\n        <img \n          loading=\"lazy\" \n          src=\"").concat(image, "\" \n          width=\"100\" \n          height=\"120\" \n          alt=\"").concat(productData.title, "\" \n        />\n      </div>\n      \n      <div class=\"decor\">\n         <svg class=\"decor__item decor__item--right\" xmlns=\"http://www.w3.org/2000/svg\" width=\"10\" height=\"10\" viewBox=\"0 0 100 100\">\n              <path d=\"M 5 95 C 35 88, 70 65, 95 15 L 95 95 Z\" fill=\"#f5f5f5\"></path>\n            </svg>\n            <svg class=\"decor__item decor__item--left\" xmlns=\"http://www.w3.org/2000/svg\" width=\"10\" height=\"10\" viewBox=\"0 0 100 100\">\n              <path d=\"M 5 95 C 35 88, 70 65, 95 15 L 95 95 Z\" fill=\"#f5f5f5\"></path>\n            </svg>\n        <button \n          type=\"button\" \n          class=\"quantity-btn quantity-btn--plus").concat(product.quantity >= maxQuantity ? ' disabled' : '', "\"\n          aria-label=\"Add quantity\"\n          ").concat(product.quantity >= maxQuantity ? 'disabled' : '', "\n        >\n          <svg xmlns=\"http://www.w3.org/2000/svg\" width=\"10\" height=\"10\" viewBox=\"0 0 10 10\" fill=\"none\">\n            <g clip-path=\"url(#clip0_11030_758)\">\n              <path d=\"M8.44444 3.86772H5.28042V0.703704C5.28042 0.31746 4.96296 0 4.57672 0C4.19048 0 3.87302 0.31746 3.87302 0.703704V3.86772H0.703704C0.31746 3.86772 0 4.18518 0 4.57143C0 4.95767 0.31746 5.27513 0.703704 5.27513H3.86772V8.43915C3.86772 8.8254 4.18518 9.14286 4.57143 9.14286C4.95767 9.14286 5.27513 8.8254 5.27513 8.43915V5.27513H8.43915C8.8254 5.27513 9.14286 4.95767 9.14286 4.57143C9.14286 4.18518 8.8254 3.86772 8.43915 3.86772H8.44444Z\" fill=\"white\"/>\n            </g>\n            <defs>\n              <clipPath id=\"clip0_11030_758\">\n                <rect width=\"9.14286\" height=\"9.14286\" fill=\"white\"/>\n              </clipPath>\n            </defs>\n          </svg>\n        </button>\n      </div>\n    </div>\n\n    <div class=\"product-card__info\">\n      <div class=\"product-card__info-title\">\n        <h3>").concat(productData.title, "</h3>\n        <p>").concat(productData.type, "</p>\n      </div>\n\n      <p class=\"product-card__info-price\">\n        <span class=\"product-card__info-quantity-detail\">\n          ").concat(formatQuantityDisplay(), "\n        </span>\n        <span class=\"product-card__info-price-per-kg\">\n          ").concat(pricePerUnit.displayText.replace('.', ','), "\n        </span>\n      </p>\n\n      <div class=\"product-card__info-quantity\">\n        <div class=\"product-card__info-quantity-display\">\n          <span class=\"quantity-selector__label\">").concat(this.translations.stuk, "</span> \n          <span class=\"quantity-value\">").concat(product.quantity, "</span>\n        </div>\n\n        <div class=\"product-card__info-price-total\">\n          ").concat(prices.hasDiscount && comparePriceDisplay ? "\n            <p class=\"product-card__info-price-total-old-price\">\n              ".concat(comparePriceDisplay).concat(this.upsellPriceType === 'price_per_day' ? this.translations.perDay : '', "\n            </p>\n          ") : '', "\n          <p class=\"product-card__info-price-total-price product-total-price\" data-price-per-day=\"").concat(pricePerDayValue, "\">\n            ").concat(priceDisplay, "\n          </p>\n        </div>\n      </div>\n    </div>\n\n    <button \n      type=\"button\" \n      class=\"product-card__delete\"\n      aria-label=\"Remove product\"\n    >\n      <svg xmlns=\"http://www.w3.org/2000/svg\" width=\"12\" height=\"16\" viewBox=\"0 0 12 16\" fill=\"none\">\n        <path d=\"M10.4302 2.03081H7.5708V0.982123C7.5708 0.550312 7.23039 0.200195 6.81056 0.200195H4.59305C4.17322 0.200195 3.83281 0.550312 3.83281 0.982123V2.03081H0.973403C0.547085 2.03081 0.200195 2.38759 0.200195 2.82607V4.02147C0.200195 4.45995 0.547085 4.81673 0.973403 4.81673H1.06742L1.87953 13.0528C2.00273 14.2966 2.89102 15.2002 3.99005 15.2002H7.41032C8.51097 15.2002 9.39926 14.2966 9.52084 13.0528L10.3329 4.81673H10.427C10.8533 4.81673 11.2002 4.45995 11.2002 4.02147V2.82607C11.2034 2.38759 10.8565 2.03081 10.4302 2.03081ZM4.32721 0.982123C4.32721 0.832073 4.44717 0.708698 4.59305 0.708698H6.81218C6.95969 0.708698 7.07802 0.832073 7.07802 0.982123V2.03081H4.32721V0.982123ZM9.0313 13.0011C8.93404 13.9798 8.25323 14.6917 7.41194 14.6917H3.99167C3.15038 14.6917 2.46957 13.9815 2.37231 13.0011L1.56506 4.81673H9.83855L9.0313 13.0011ZM10.709 4.02147C10.709 4.17986 10.5842 4.30823 10.4302 4.30823H0.975024C0.821031 4.30823 0.696216 4.17986 0.696216 4.02147V2.82607C0.696216 2.66768 0.821031 2.53931 0.975024 2.53931H10.4318C10.5858 2.53931 10.7106 2.66768 10.7106 2.82607V4.02147H10.709ZM5.45542 11.7024V6.97745C5.45542 6.83741 5.56564 6.72404 5.70181 6.72404C5.83797 6.72404 5.94819 6.83741 5.94819 6.97745V11.7024C5.94819 11.8424 5.83797 11.9558 5.70181 11.9558C5.56564 11.9558 5.45542 11.8441 5.45542 11.7024ZM3.61722 11.7024V6.97745C3.61722 6.83741 3.72745 6.72404 3.86361 6.72404C3.99978 6.72404 4.11 6.83741 4.11 6.97745V11.7024C4.11 11.8424 3.99978 11.9558 3.86361 11.9558C3.72745 11.9558 3.61722 11.8441 3.61722 11.7024ZM7.29199 11.7024V6.97745C7.29199 6.83741 7.40221 6.72404 7.53838 6.72404C7.67454 6.72404 7.78477 6.83741 7.78477 6.97745V11.7024C7.88477 11.8424 7.67454 11.9558 7.53838 11.9558C7.40221 11.9558 7.29199 11.8441 7.29199 11.7024Z\" fill=\"#1B1B1B\" fill-opacity=\"0.3\"/>\n        <path d=\"M6.81055 0.100586C7.28824 0.100586 7.6709 0.498053 7.6709 0.982422V1.93066H10.4307C10.9143 1.93092 11.3031 2.33487 11.2998 2.82617V4.02148C11.2998 4.51252 10.9109 4.91699 10.4268 4.91699H10.4238L9.62012 13.0625C9.49457 14.3469 8.57225 15.2998 7.41016 15.2998H3.99023C2.8297 15.2998 1.90747 14.3467 1.78027 13.0625L0.976562 4.91699H0.973633C0.489459 4.91699 0.100594 4.51252 0.100586 4.02148V2.82617C0.100586 2.33513 0.489454 1.93066 0.973633 1.93066H3.73242V0.982422C3.73242 0.498148 4.11521 0.100742 4.59277 0.100586H6.81055ZM2.47168 12.9912C2.56515 13.9334 3.21377 14.5915 3.99121 14.5918H7.41211C8.18962 14.5917 8.83815 13.9319 8.93164 12.9912L9.72852 4.91699H1.67578L2.47168 12.9912ZM3.86328 6.62402C4.05731 6.62402 4.20996 6.78493 4.20996 6.97754V11.7021C4.20996 11.8948 4.05731 12.0557 3.86328 12.0557C3.66984 12.0555 3.51758 11.8967 3.51758 11.7021V6.97754C3.51758 6.78504 3.66942 6.62421 3.86328 6.62402ZM5.70215 6.62402C5.89601 6.62421 6.04785 6.78505 6.04785 6.97754V11.7021C6.04785 11.8946 5.89601 12.0557 5.70215 12.0557C5.50855 12.0557 5.35547 11.8969 5.35547 11.7021V6.97754C5.35547 6.78493 5.50812 6.62402 5.70215 6.62402ZM7.53809 6.62402C7.73211 6.62402 7.88477 6.78493 7.88477 6.97754V11.7021C7.88477 11.8948 7.73211 12.0557 7.53809 12.0557C7.34462 12.0555 7.19238 11.8968 7.19238 11.7021V6.97754C7.19238 6.78503 7.3442 6.62418 7.53809 6.62402ZM0.974609 2.63965C0.878655 2.63988 0.795898 2.7205 0.795898 2.82617V4.02148C0.795906 4.12715 0.878659 4.20778 0.974609 4.20801H10.4307C10.5266 4.20775 10.6094 4.12714 10.6094 4.02148V3.92188H10.6104V2.82617C10.6104 2.72034 10.5278 2.63965 10.4316 2.63965H0.974609ZM4.59277 0.808594C4.50486 0.808755 4.42676 0.885034 4.42676 0.982422V1.93066H6.97754V0.982422C6.97754 0.884645 6.90162 0.808775 6.8125 0.808594H4.59277Z\" stroke=\"#1B1B1B\" stroke-opacity=\"0.3\" stroke-width=\"0.2\"/>\n      </svg>\n    </button>\n  ");
      return card;
    }

    /**
     * Get selling plan data for subscription pricing
     * Prefers plan with '4 weeks' in name, fallback to first plan
     */
  }, {
    key: "getSellingPlanData",
    value: function getSellingPlanData(productData) {
      if (!productData.selling_plan_groups || productData.selling_plan_groups.length === 0) {
        return null;
      }
      var group = productData.selling_plan_groups[0];
      if (!group.selling_plans || group.selling_plans.length === 0) {
        return null;
      }

      // Search for plan with '4 weeks' in name (case insensitive)
      var plan = group.selling_plans.find(function (p) {
        var name = (p.name || '').toLowerCase();
        return name.includes('4 weeks') || name.includes('4 wochen');
      });

      // Fallback to first plan if '4 weeks' plan not found
      if (!plan) {
        plan = group.selling_plans[0];
      }
      var adjustment = plan.price_adjustments[0];
      if (!adjustment) return null;
      var discount = '';
      if (adjustment.value_type === 'percentage') {
        discount = "".concat(adjustment.value, "%");
      } else if (adjustment.value_type === 'fixed_amount') {
        discount = "\u20AC".concat((adjustment.value / 100).toFixed(2));
      }
      return {
        id: plan.id,
        discount: discount,
        adjustment: adjustment
      };
    }
  }, {
    key: "getDiscountData",
    value: function getDiscountData() {
      if (!this._discountData) {
        var el = document.getElementById('discount-data');
        if (!el) {
          console.warn('discount-data script not found');
          this._discountData = [];
          return this._discountData;
        }
        var text = el.textContent.trim();
        try {
          this._discountData = JSON.parse(text);
        } catch (e) {
          console.error('Failed to parse discount-data JSON', e, text);
          this._discountData = [];
        }
      }
      return this._discountData;
    }
  }, {
    key: "getDiscountByHandle",
    value: function getDiscountByHandle(handle) {
      var _item$metafields;
      var arr = this.getDiscountData();
      var item = arr.find(function (i) {
        return i.handle === handle;
      });
      if (!item || !((_item$metafields = item.metafields) !== null && _item$metafields !== void 0 && (_item$metafields = _item$metafields.custom) !== null && _item$metafields !== void 0 && _item$metafields.percentage_adjustment_decimal)) {
        return 0;
      }
      var value = parseFloat(item.metafields.custom.percentage_adjustment_decimal);
      return isNaN(value) ? 0 : value;
    }
  }, {
    key: "getCheckoutMode",
    value: function getCheckoutMode() {
      return (this.dataset.checkoutMode || this.checkoutMode || 'cart').toLowerCase();
    }
  }, {
    key: "getDiscountCodeFromUrl",
    value: function getDiscountCodeFromUrl() {
      var params = new URLSearchParams(window.location.search || '');
      var keys = ['discount', 'discount_code', 'discountCode', 'code', 'coupon', 'promo', 'promocode'];
      for (var _i = 0, _keys = keys; _i < _keys.length; _i++) {
        var key = _keys[_i];
        var value = params.get(key);
        if (value && value.trim()) {
          return value.trim();
        }
      }
      return '';
    }
  }, {
    key: "getDiscountCodeFromCookie",
    value: function getDiscountCodeFromCookie() {
      var cookies = document.cookie ? document.cookie.split(';') : [];
      var names = ['discount_code', 'discount', 'discountCode'];
      var _iterator8 = _createForOfIteratorHelper(cookies),
        _step8;
      try {
        for (_iterator8.s(); !(_step8 = _iterator8.n()).done;) {
          var rawCookie = _step8.value;
          var _rawCookie$split = rawCookie.split('='),
            _rawCookie$split2 = _toArray(_rawCookie$split),
            name = _rawCookie$split2[0],
            rest = _rawCookie$split2.slice(1);
          if (!name || rest.length === 0) continue;
          var key = name.trim();
          if (!names.includes(key)) continue;
          var value = rest.join('=').trim();
          if (value) {
            return decodeURIComponent(value);
          }
        }
      } catch (err) {
        _iterator8.e(err);
      } finally {
        _iterator8.f();
      }
      return '';
    }
  }, {
    key: "getStoredDiscountCode",
    value: function getStoredDiscountCode() {
      var storedSession = sessionStorage.getItem(this.discountStorageKey);
      if (storedSession && storedSession.trim()) {
        return storedSession.trim();
      }
      return '';
    }
  }, {
    key: "setStoredDiscountCode",
    value: function setStoredDiscountCode(code) {
      if (!code || !code.trim()) return;
      var cleanCode = code.trim();
      sessionStorage.setItem(this.discountStorageKey, cleanCode);
    }
  }, {
    key: "getCheckoutDiscountCode",
    value: function getCheckoutDiscountCode() {
      var stored = this.getStoredDiscountCode();
      if (stored) return stored;
      var urlCode = this.getDiscountCodeFromUrl();
      if (urlCode) {
        this.setStoredDiscountCode(urlCode);
        return urlCode;
      }
      var cookieCode = this.getDiscountCodeFromCookie();
      if (cookieCode) return cookieCode;
      return 'SAVE30';
    }
  }, {
    key: "buildCheckoutUrlWithDiscount",
    value: function buildCheckoutUrlWithDiscount() {
      var discountCode = this.getCheckoutDiscountCode();
      if (discountCode) {
        return "/discount/".concat(encodeURIComponent(discountCode), "?redirect=/checkout");
      }
      return '/checkout';
    }
  }, {
    key: "trackCheckoutStart",
    value: function trackCheckoutStart() {
      var checkoutEvent = {
        event: 'start_checkout',
        checkout_type: 'quiz'
      };
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push(checkoutEvent);
    }

    /**
     * Calculate subscription price with discount (matching Liquid logic)
     */
  }, {
    key: "calculateSubscriptionPrice",
    value: function calculateSubscriptionPrice(variant, productData) {
      var basePrice = variant.price / 100;
      var discountedPrice = basePrice;
      var discountAbsolute = 0;
      var sellingPlan = this.getSellingPlanData(productData);
      var extraPercentage = this.getDiscountByHandle(productData.handle);
      console.log(extraPercentage, 'extraPercentage');
      console.log(productData.handle, 'productData.handle');
      if (sellingPlan && sellingPlan.adjustment) {
        var adjustment = sellingPlan.adjustment;
        var variantPrice = variant.price;
        switch (adjustment.value_type) {
          case 'percentage':
            {
              var totalPercent = adjustment.value + extraPercentage;
              discountAbsolute = variantPrice * totalPercent / 10000;
              discountedPrice = basePrice - discountAbsolute;
              break;
            }
          case 'fixed_amount':
            discountAbsolute = adjustment.value / 100;
            discountedPrice = basePrice - discountAbsolute;
            break;
          case 'price':
            discountedPrice = adjustment.value / 100;
            discountAbsolute = basePrice - discountedPrice;
            break;
        }
      } else {
        // No selling plan — но всё равно применяем JSON discount
        if (extraPercentage > 0) {
          discountAbsolute = variant.price * extraPercentage / 10000;
          discountedPrice = basePrice - discountAbsolute;
        }
      }
      return {
        originalPrice: basePrice,
        discountedPrice: discountedPrice,
        discountAbsolute: discountAbsolute,
        hasDiscount: discountAbsolute > 0
      };
    }

    /**
     * Calculate price per day for a product
     * @param {number} totalPrice - Total price for quantity
     * @param {number} quantity - Product quantity (not used in calculation, kept for compatibility)
     * @param {number|null} daysLasts - Optional: number of days product lasts (if null, uses default 28)
     * @returns {number} Price per day
     */
  }, {
    key: "calculatePricePerDay",
    value: function calculatePricePerDay(unitPrice, quantity, daysLasts) {
      var days = daysLasts || 28; // 28 as absolute fallback

      var totalPrice = unitPrice * quantity;
      var totalDays = days * quantity;

      // Price per day = total price / total days
      var pricePerDay = totalPrice / totalDays;
      console.log("[Price/Day] Unit: \u20AC".concat(unitPrice.toFixed(2), ", Qty: ").concat(quantity, ", Days/unit: ").concat(days, " \u2192 \u20AC").concat(pricePerDay.toFixed(2), "/day"));
      return pricePerDay;
    }

    /**
     * Build price-per-unit info (kg, 100g, g) based on product type
     */
  }, {
    key: "getPricePerUnitInfo",
    value: function getPricePerUnitInfo(product, variant, productData, discountedPrice) {
      var handle = (product.handle || (productData === null || productData === void 0 ? void 0 : productData.handle) || '').toLowerCase();
      var type = (product.type || (productData === null || productData === void 0 ? void 0 : productData.product_type) || '').toLowerCase();
      var grams = product.gramsPerUnit || (variant === null || variant === void 0 ? void 0 : variant.grams) || (variant === null || variant === void 0 ? void 0 : variant.weight) || 0;
      if (!grams || Number.isNaN(grams) || grams <= 0) {
        grams = 1000;
      }
      var isSnackOrDental = product.type === 'snacks' || type.includes('snack') || type.includes('dental') || type.includes('stick') || handle.includes('snack') || handle.includes('dental');
      var isSupplement = handle.includes('digestive-delight') || handle.includes('mighty-mobility') || type.includes('supplement');
      var unitLabel = 'kg';
      var divisor = grams / 1000;
      if (isSnackOrDental) {
        unitLabel = '100g';
        divisor = grams / 100;
      } else if (isSupplement) {
        unitLabel = 'g';
        divisor = grams;
      }
      var pricePerUnit = divisor > 0 ? discountedPrice / divisor : 0;
      var rawLabel = this.translations.pricePerKg || '';
      var label = rawLabel && rawLabel.toLowerCase().includes('kg') ? rawLabel.replace(/kg/gi, unitLabel) : "Preis/".concat(unitLabel);
      return {
        pricePerUnit: pricePerUnit,
        unitLabel: unitLabel,
        displayText: pricePerUnit > 0 ? "".concat(label, " \u20AC").concat(pricePerUnit.toFixed(2)) : ''
      };
    }

    /**
     * Get list of deleted products from localStorage
     */
  }, {
    key: "getDeletedProducts",
    value: function getDeletedProducts() {
      try {
        var deleted = localStorage.getItem('quiz_deleted_products');
        return deleted ? JSON.parse(deleted) : [];
      } catch (error) {
        console.error('Error loading deleted products:', error);
        return [];
      }
    }

    /**
     * Save deleted product to localStorage
     */
  }, {
    key: "saveDeletedProduct",
    value: function saveDeletedProduct(handle) {
      try {
        var deleted = this.getDeletedProducts();
        if (!deleted.includes(handle)) {
          deleted.push(handle);
          localStorage.setItem('quiz_deleted_products', JSON.stringify(deleted));
        }
      } catch (error) {
        console.error('Error saving deleted product:', error);
      }
    }

    /**
     * Setup event listeners for quantity changes and deletion
     */
  }, {
    key: "setupEventListeners",
    value: function setupEventListeners() {
      var _this5 = this;
      // Remove first if already added (safety)
      this.removeEventListener('click', this._onClick);
      this.addEventListener('click', this._onClick);

      // Add touchend for mobile Safari/Chrome compatibility
      if (!this._touchEndBound) {
        this._touchEndBound = true;
        this.addEventListener('touchend', function (e) {
          _this5._lastTouchTime = Date.now();
          // Small delay to allow click to fire first, prevent double handling
          var target = e.target;
          setTimeout(function () {
            if (target.closest('.quantity-btn--plus, .quantity-btn--minus, .product-card__delete')) {
              _this5._onClick(e);
            }
          }, 10);
        }, {
          passive: false
        });
      }

      // Setup listeners for recommendation product
      this.setupRecommendationListeners();

      // Add to cart button (find in parent quiz section)
      var addToCartBtn = document.querySelector('.primary--btn-buy, .add-to-cart-btn');
      if (addToCartBtn) {
        addToCartBtn.removeEventListener('click', this._onAddToCartClick);
        addToCartBtn.addEventListener('click', this._onAddToCartClick);
      }
    }

    /**
     * Central click handler delegated for internal card actions
     * NOTE: Recommendation products have their own direct handlers in setupRecommendationListeners(),
     * so we exclude them here to prevent double event handling (quantity +/- by 2 instead of 1)
     */
  }, {
    key: "_onClick",
    value: function _onClick(e) {
      if (e.type === 'click' && this._lastTouchTime && Date.now() - this._lastTouchTime < 500) {
        return;
      }
      var plusBtn = e.target.closest('.quantity-btn--plus');
      if (plusBtn) {
        var card = plusBtn.closest('.product-card');
        // Skip recommendation products - they have direct handlers in setupRecommendationListeners()
        if (card && card.classList.contains('recommendation-product')) {
          return;
        }
        e.preventDefault();
        e.stopPropagation();
        this.increaseQuantity(card);
        return;
      }
      var minusBtn = e.target.closest('.quantity-btn--minus');
      if (minusBtn) {
        var _card = minusBtn.closest('.product-card');
        // Skip recommendation products - they have direct handlers in setupRecommendationListeners()
        if (_card && _card.classList.contains('recommendation-product')) {
          return;
        }
        e.preventDefault();
        e.stopPropagation();
        this.decreaseQuantity(_card);
        return;
      }
      var deleteBtn = e.target.closest('.product-card__delete');
      if (deleteBtn) {
        var _card2 = deleteBtn.closest('.product-card');
        // Skip recommendation products - they have direct handlers in setupRecommendationListeners()
        if (_card2 && _card2.classList.contains('recommendation-product')) {
          return;
        }
        e.preventDefault();
        e.stopPropagation();
        this.deleteProduct(_card2);
        return;
      }
    }

    /**
     * Setup event listeners for recommendation product buttons
     */
  }, {
    key: "setupRecommendationListeners",
    value: function setupRecommendationListeners() {
      var _this6 = this;
      var recCard = document.querySelector('.recommendation-product');
      if (!recCard) return;

      // Remove old listeners if any
      var oldPlusBtn = recCard.querySelector('.quantity-btn--plus');
      var oldMinusBtn = recCard.querySelector('.quantity-btn--minus');
      var oldDeleteBtn = recCard.querySelector('.product-card__delete');
      if (oldPlusBtn) {
        oldPlusBtn.replaceWith(oldPlusBtn.cloneNode(true));
      }
      if (oldMinusBtn) {
        oldMinusBtn.replaceWith(oldMinusBtn.cloneNode(true));
      }
      if (oldDeleteBtn) {
        oldDeleteBtn.replaceWith(oldDeleteBtn.cloneNode(true));
      }

      // Add new listeners
      var plusBtn = recCard.querySelector('.quantity-btn--plus');
      var minusBtn = recCard.querySelector('.quantity-btn--minus');
      var deleteBtn = recCard.querySelector('.product-card__delete');

      // Helper function to add both click and touchend handlers for mobile compatibility
      var addMobileCompatibleListener = function addMobileCompatibleListener(btn, handler) {
        if (!btn) return;
        var lastTouchTime = 0;
        var handleEvent = function handleEvent(e) {
          if (e.type === 'click' && lastTouchTime && Date.now() - lastTouchTime < 500) {
            return;
          }
          if (e.type === 'touchend') {
            lastTouchTime = Date.now();
          }
          e.preventDefault();
          e.stopPropagation();
          handler();
        };
        btn.addEventListener('click', handleEvent);
        btn.addEventListener('touchend', handleEvent, {
          passive: false
        });
      };
      addMobileCompatibleListener(plusBtn, function () {
        return _this6.increaseQuantity(recCard);
      });
      addMobileCompatibleListener(minusBtn, function () {
        return _this6.decreaseQuantity(recCard);
      });
      addMobileCompatibleListener(deleteBtn, function () {
        return _this6.deleteProduct(recCard);
      });
    }
  }, {
    key: "_onAddToCartClick",
    value: function _onAddToCartClick(e) {
      e.preventDefault();
      this.addAllToCart()["catch"](function (err) {
        return console.error('addAllToCart error:', err);
      });
    }

    /**
     * Increase product quantity
     */
  }, {
    key: "increaseQuantity",
    value: function increaseQuantity(card) {
      var handle = card.dataset.handle;
      var isRecommendation = card.classList.contains('recommendation-product');
      if (isRecommendation && this.recommendationProduct) {
        this.recommendationProduct.quantity += 1;
        this.updateRecommendationCard(card);
        this.updateTotalPrice();
      } else {
        var product = this.products.find(function (p) {
          return p.handle === handle;
        });
        if (product) {
          product.quantity += 1;
          this.updateCardQuantityAndPrice(card, product);
          this.updateTotalPrice();
          // Update localStorage with new quantities
          this.saveProductQuantitiesToLocalStorage();
        }
      }
    }

    /**
     * Decrease product quantity (minimum 1)
     */
  }, {
    key: "decreaseQuantity",
    value: function decreaseQuantity(card) {
      var handle = card.dataset.handle;
      var isRecommendation = card.classList.contains('recommendation-product');
      if (isRecommendation && this.recommendationProduct) {
        if (this.recommendationProduct.quantity > 1) {
          this.recommendationProduct.quantity -= 1;
          this.updateRecommendationCard(card);
          this.updateTotalPrice();
        }
      } else {
        var product = this.products.find(function (p) {
          return p.handle === handle;
        });
        if (product && product.quantity > 1) {
          product.quantity -= 1;
          this.updateCardQuantityAndPrice(card, product);
          this.updateTotalPrice();
          // Update localStorage with new quantities
          this.saveProductQuantitiesToLocalStorage();
        }
      }
    }
  }, {
    key: "updateRecommendationCard",
    value: function () {
      var _updateRecommendationCard = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee7(card) {
        var _this7 = this;
        var handle, quantity, _productData, productData, variant, prices, singleUnitPrice, qEl, qDetailEl, title, type, match, cansCount, gramsPerCan, _match, kgPerBag, _match2, gramsPerPack, recGrams, daysLasts, oldPriceEl, comparePriceText, totalOriginalPrice, comparePricePerDay, priceDisplayText, priceValue, totalPrice, pricePerDay, priceEl, maxQuantity, minusBtn, plusBtn;
        return _regenerator().w(function (_context7) {
          while (1) switch (_context7.n) {
            case 0:
              if (this.recommendationProduct) {
                _context7.n = 1;
                break;
              }
              return _context7.a(2);
            case 1:
              handle = this.recommendationProduct.handle;
              quantity = this.recommendationProduct.quantity;
              if (this.productData.has(handle)) {
                _context7.n = 3;
                break;
              }
              _context7.n = 2;
              return this.fetchProductData(handle);
            case 2:
              _productData = _context7.v;
              if (_productData) {
                this.productData.set(handle, _productData);
              }
            case 3:
              productData = this.productData.get(handle);
              if (productData) {
                _context7.n = 4;
                break;
              }
              return _context7.a(2);
            case 4:
              variant = productData.variants.find(function (v) {
                return v.sku === _this7.recommendationProduct.sku;
              }) || productData.variants[0];
              prices = this.calculateSubscriptionPrice(variant, productData);
              singleUnitPrice = prices.discountedPrice; // Update quantity display
              qEl = card.querySelector('.quantity-value');
              if (qEl) qEl.textContent = quantity;
              qDetailEl = card.querySelector('.product-card__info-quantity-detail');
              if (qDetailEl) {
                title = variant.title.trim();
                type = this.recommendationProduct.type || 'unknown';
                if (type === 'wet' && title.match(/^\d+x\s*\d+g/i)) {
                  match = title.match(/(\d+)x\s*(\d+)g/i);
                  if (match) {
                    cansCount = parseInt(match[1], 10);
                    gramsPerCan = parseInt(match[2], 10);
                    qDetailEl.textContent = "".concat(quantity * cansCount, "x").concat(gramsPerCan, "g");
                  }
                } else if (type === 'dry' && title.match(/^\d+kg/i)) {
                  _match = title.match(/(\d+)kg/i);
                  if (_match) {
                    kgPerBag = parseInt(_match[1], 10);
                    qDetailEl.textContent = "".concat(quantity, "x").concat(kgPerBag, "kg");
                  }
                } else if (type === 'snacks' && title.match(/^\d+g/i)) {
                  _match2 = title.match(/(\d+)g/i);
                  if (_match2) {
                    gramsPerPack = parseInt(_match2[1], 10);
                    qDetailEl.textContent = "".concat(quantity, "x").concat(gramsPerPack, "g");
                  }
                }
              }

              // Get actual grams from variant
              recGrams = parseInt(card.dataset.grams) || variant.grams || variant.weight || 0;
              daysLasts = this.calculateDaysProductLasts({
                type: this.recommendationProduct.type,
                gramsPerUnit: recGrams,
                quantity: 1
              });
              console.log("[Update Rec Card] ".concat(handle, ": Price \u20AC").concat(singleUnitPrice.toFixed(2), ", Qty: ").concat(quantity, ", Days/unit: ").concat(daysLasts, ", Grams: ").concat(recGrams));

              // Update compare price if discount exists
              oldPriceEl = card.querySelector('.product-card__info-price-total-old-price');
              if (oldPriceEl) {
                if (prices.hasDiscount) {
                  if (this.upsellPriceType === 'default_price') {
                    totalOriginalPrice = prices.originalPrice * quantity;
                    comparePriceText = "\u20AC".concat(totalOriginalPrice.toFixed(2).replace('.', ','));
                  } else {
                    comparePricePerDay = this.calculatePricePerDay(prices.originalPrice, quantity, daysLasts);
                    comparePriceText = "\u20AC".concat(comparePricePerDay.toFixed(2).replace('.', ',')).concat(this.translations.perDay);
                  }
                  oldPriceEl.textContent = comparePriceText;
                  oldPriceEl.style.display = '';
                } else {
                  oldPriceEl.style.display = 'none';
                }
              }

              // Calculate price display based on upsellPriceType

              if (this.upsellPriceType === 'default_price') {
                // Default price mode: show total price without day division
                totalPrice = singleUnitPrice * quantity;
                priceDisplayText = "\u20AC".concat(totalPrice.toFixed(2).replace('.', ','));
                priceValue = totalPrice;
              } else {
                // Price per day mode (current behavior)
                pricePerDay = this.calculatePricePerDay(singleUnitPrice, quantity, daysLasts);
                priceDisplayText = "\u20AC".concat(pricePerDay.toFixed(2).replace('.', ',')).concat(this.translations.perDay);
                priceValue = pricePerDay;
              }
              priceEl = card.querySelector('.product-total-price');
              if (priceEl) {
                priceEl.textContent = priceDisplayText;
                priceEl.dataset.pricePerDay = priceValue;
              }

              // Update button states (rest of code unchanged)
              maxQuantity = variant.inventory_quantity || 99;
              minusBtn = card.querySelector('.quantity-btn--minus');
              plusBtn = card.querySelector('.quantity-btn--plus');
              if (minusBtn) {
                if (quantity <= 1) {
                  minusBtn.disabled = true;
                  minusBtn.classList.add('disabled');
                } else {
                  minusBtn.disabled = false;
                  minusBtn.classList.remove('disabled');
                }
              }
              if (plusBtn) {
                if (quantity >= maxQuantity) {
                  plusBtn.disabled = true;
                  plusBtn.classList.add('disabled');
                } else {
                  plusBtn.disabled = false;
                  plusBtn.classList.remove('disabled');
                }
              }
            case 5:
              return _context7.a(2);
          }
        }, _callee7, this);
      }));
      function updateRecommendationCard(_x2) {
        return _updateRecommendationCard.apply(this, arguments);
      }
      return updateRecommendationCard;
    }()
    /**
     * Delete product from list
     */
  }, {
    key: "deleteProduct",
    value: function deleteProduct(card) {
      var handle = card.dataset.handle;
      var isRecommendation = card.classList.contains('recommendation-product');

      // Save to deleted products list
      this.saveDeletedProduct(handle);
      if (isRecommendation) {
        // Remove recommendation product
        this.recommendationProduct = null;
        card.remove();
        // Hide recommendation text when product is deleted
        var recText = document.querySelector('.recommendation-text');
        if (recText) {
          recText.style.display = 'none';
        }
        console.log('Recommendation product removed:', handle);
      } else {
        // Remove from products array
        var index = this.products.findIndex(function (p) {
          return p.handle === handle;
        });
        if (index > -1) {
          this.products.splice(index, 1);
          card.remove();
          console.log('Product removed:', handle);
        }
      }

      // Update total price after deletion
      this.updateTotalPrice();
      // Update localStorage with new quantities
      this.saveProductQuantitiesToLocalStorage();
      console.log('Remaining products:', this.products);
    }

    /**
     * Update card UI after quantity change - only Stück and price per day
     */
  }, {
    key: "updateCardQuantityAndPrice",
    value: function updateCardQuantityAndPrice(card, product) {
      var productData = this.productData.get(product.handle);
      if (!productData) return;
      var variant = productData.variants.find(function (v) {
        return v.sku === product.sku;
      }) || productData.variants[0];
      var prices = this.calculateSubscriptionPrice(variant, productData);
      var singleUnitPrice = prices.discountedPrice;

      // Update quantity display
      var qEl = card.querySelector('.quantity-value');
      if (qEl) qEl.textContent = product.quantity;

      // Calculate days for ONE unit
      var daysLasts = this.calculateDaysProductLasts({
        type: product.type,
        gramsPerUnit: product.gramsPerUnit || 0,
        quantity: 1
      });
      console.log("[Update Card] ".concat(product.handle, ": Price \u20AC").concat(singleUnitPrice.toFixed(2), ", Qty: ").concat(product.quantity, ", Days/unit: ").concat(daysLasts, ", GramsPerUnit: ").concat(product.gramsPerUnit));

      // Calculate price display based on upsellPriceType
      var priceDisplayText;
      var priceValue;
      if (this.upsellPriceType === 'default_price') {
        // Default price mode: show total price without day division
        var totalPrice = singleUnitPrice * product.quantity;
        priceDisplayText = "\u20AC".concat(totalPrice.toFixed(2).replace('.', ','));
        priceValue = totalPrice;
      } else {
        // Price per day mode (current behavior)
        var pricePerDay = this.calculatePricePerDay(singleUnitPrice, product.quantity, daysLasts);
        priceDisplayText = "\u20AC".concat(pricePerDay.toFixed(2).replace('.', ',')).concat(this.translations.perDay);
        priceValue = pricePerDay;
      }

      // Update compare (old) price if exists
      var oldPriceEl = card.querySelector('.product-card__info-price-total-old-price');
      if (oldPriceEl) {
        if (prices.hasDiscount) {
          var comparePriceText;
          if (this.upsellPriceType === 'default_price') {
            var totalOriginalPrice = prices.originalPrice * product.quantity;
            comparePriceText = "\u20AC".concat(totalOriginalPrice.toFixed(2).replace('.', ','));
          } else {
            var comparePricePerDay = this.calculatePricePerDay(prices.originalPrice, product.quantity, daysLasts);
            comparePriceText = "\u20AC".concat(comparePricePerDay.toFixed(2).replace('.', ',')).concat(this.translations.perDay);
          }
          oldPriceEl.textContent = comparePriceText;
          oldPriceEl.style.display = '';
        } else {
          oldPriceEl.style.display = 'none';
        }
      }
      var priceEl = card.querySelector('.product-total-price');
      if (priceEl) {
        priceEl.textContent = priceDisplayText;
        priceEl.dataset.pricePerDay = priceValue;
      }

      // Update button states (rest of code unchanged)
      var maxQuantity = parseInt(card.dataset.maxQuantity) || 99;
      var minusBtn = card.querySelector('.quantity-btn--minus');
      var plusBtn = card.querySelector('.quantity-btn--plus');
      if (minusBtn) {
        if (product.quantity <= 1) {
          minusBtn.disabled = true;
          minusBtn.classList.add('disabled');
        } else {
          minusBtn.disabled = false;
          minusBtn.classList.remove('disabled');
        }
      }
      if (plusBtn) {
        if (product.quantity >= maxQuantity) {
          plusBtn.disabled = true;
          plusBtn.classList.add('disabled');
        } else {
          plusBtn.disabled = false;
          plusBtn.classList.remove('disabled');
        }
      }
    }

    /**
     * Calculate and update total price in the DOM
     */
  }, {
    key: "updateTotalPrice",
    value: (function () {
      var _updateTotalPrice = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee8() {
        var _this8 = this;
        var totalDiscountedPriceSum, totalOriginalPriceSum, hasAnyDiscount, _iterator9, _step9, _loop, handle, _productData2, productData, variant, prices, recCard, recGrams, daysLasts, dailyPriceUnit, dailyOriginalUnit, isPerDay, suffix, totalPriceEl, comparePriceEl, crossedPriceSelectors, _t5;
        return _regenerator().w(function (_context9) {
          while (1) switch (_context9.n) {
            case 0:
              totalDiscountedPriceSum = 0;
              totalOriginalPriceSum = 0;
              hasAnyDiscount = false;
              _iterator9 = _createForOfIteratorHelper(this.products);
              _context9.p = 1;
              _loop = /*#__PURE__*/_regenerator().m(function _loop() {
                var product, productData, variant, prices, _daysLasts, _dailyPriceUnit, _dailyOriginalUnit;
                return _regenerator().w(function (_context8) {
                  while (1) switch (_context8.n) {
                    case 0:
                      product = _step9.value;
                      productData = _this8.productData.get(product.handle);
                      if (productData) {
                        _context8.n = 1;
                        break;
                      }
                      return _context8.a(2, 1);
                    case 1:
                      variant = product.sku ? productData.variants.find(function (v) {
                        return v.sku === product.sku;
                      }) || productData.variants[0] : productData.variants[0];
                      prices = _this8.calculateSubscriptionPrice(variant, productData);
                      if (_this8.upsellPriceType === 'price_per_day') {
                        _daysLasts = _this8.calculateDaysProductLasts({
                          type: product.type,
                          gramsPerUnit: product.gramsPerUnit || 0,
                          quantity: 1
                        });
                        _dailyPriceUnit = parseFloat((prices.discountedPrice / _daysLasts).toFixed(2));
                        _dailyOriginalUnit = parseFloat((prices.originalPrice / _daysLasts).toFixed(2)); // Sum daily price per product (ignore quantity)
                        totalDiscountedPriceSum += _dailyPriceUnit;
                        totalOriginalPriceSum += _dailyOriginalUnit;
                      } else {
                        totalDiscountedPriceSum += prices.discountedPrice * product.quantity;
                        totalOriginalPriceSum += prices.originalPrice * product.quantity;
                      }
                      if (prices.hasDiscount) {
                        hasAnyDiscount = true;
                      }
                    case 2:
                      return _context8.a(2);
                  }
                }, _loop);
              });
              _iterator9.s();
            case 2:
              if ((_step9 = _iterator9.n()).done) {
                _context9.n = 5;
                break;
              }
              return _context9.d(_regeneratorValues(_loop()), 3);
            case 3:
              if (!_context9.v) {
                _context9.n = 4;
                break;
              }
              return _context9.a(3, 4);
            case 4:
              _context9.n = 2;
              break;
            case 5:
              _context9.n = 7;
              break;
            case 6:
              _context9.p = 6;
              _t5 = _context9.v;
              _iterator9.e(_t5);
            case 7:
              _context9.p = 7;
              _iterator9.f();
              return _context9.f(7);
            case 8:
              if (!this.recommendationProduct) {
                _context9.n = 11;
                break;
              }
              handle = this.recommendationProduct.handle;
              if (this.productData.has(handle)) {
                _context9.n = 10;
                break;
              }
              _context9.n = 9;
              return this.fetchProductData(handle);
            case 9:
              _productData2 = _context9.v;
              if (_productData2) {
                this.productData.set(handle, _productData2);
              }
            case 10:
              productData = this.productData.get(handle);
              if (productData) {
                variant = productData.variants[0];
                prices = this.calculateSubscriptionPrice(variant, productData);
                if (this.upsellPriceType === 'price_per_day') {
                  recCard = document.querySelector('.recommendation-product');
                  recGrams = recCard ? parseInt(recCard.dataset.grams) : variant.grams || 0;
                  daysLasts = this.calculateDaysProductLasts({
                    type: this.recommendationProduct.type,
                    gramsPerUnit: recGrams,
                    quantity: 1
                  });
                  dailyPriceUnit = parseFloat((prices.discountedPrice / daysLasts).toFixed(2));
                  dailyOriginalUnit = parseFloat((prices.originalPrice / daysLasts).toFixed(2)); // Sum daily price per product (ignore quantity)
                  totalDiscountedPriceSum += dailyPriceUnit;
                  totalOriginalPriceSum += dailyOriginalUnit;
                } else {
                  totalDiscountedPriceSum += prices.discountedPrice * this.recommendationProduct.quantity;
                  totalOriginalPriceSum += prices.originalPrice * this.recommendationProduct.quantity;
                }
                if (prices.hasDiscount) {
                  hasAnyDiscount = true;
                }
              }
            case 11:
              isPerDay = this.upsellPriceType === 'price_per_day';
              suffix = isPerDay ? this.translations.perDay : '';
              totalPriceEl = document.querySelector('[data-total-price]');
              if (totalPriceEl) {
                totalPriceEl.textContent = "\u20AC".concat(totalDiscountedPriceSum.toFixed(2).replace('.', ',')).concat(suffix);
              }
              comparePriceEl = document.querySelector('[data-total-compare-price]');
              if (comparePriceEl) {
                if (hasAnyDiscount && totalOriginalPriceSum > totalDiscountedPriceSum) {
                  comparePriceEl.textContent = "\u20AC".concat(totalOriginalPriceSum.toFixed(2).replace('.', ',')).concat(suffix);
                  comparePriceEl.classList.remove('tw-hidden');
                } else {
                  comparePriceEl.classList.add('tw-hidden');
                }
              }

              // 5. Update crossed price elements only (not main price)
              // Note: sub_label_text--original-main is used for both main and crossed price, so we exclude it
              crossedPriceSelectors = ['.sub_label_text--original.tw-line-through', '.paragraph-crossed-p1'];
              crossedPriceSelectors.forEach(function (selector) {
                var elements = document.querySelectorAll(selector);
                elements.forEach(function (el) {
                  if (hasAnyDiscount && totalOriginalPriceSum > totalDiscountedPriceSum) {
                    el.textContent = "\u20AC".concat(totalOriginalPriceSum.toFixed(2).replace('.', ',')).concat(suffix);
                    el.classList.remove('tw-hidden');
                    el.style.display = '';
                  } else {
                    el.classList.add('tw-hidden');
                    el.style.display = 'none';
                  }
                });
              });
            case 12:
              return _context9.a(2);
          }
        }, _callee8, this, [[1, 6, 7, 8]]);
      }));
      function updateTotalPrice() {
        return _updateTotalPrice.apply(this, arguments);
      }
      return updateTotalPrice;
    }()
    /**
     * Add all products to cart and redirect to checkout
     */
    )
  }, {
    key: "addAllToCart",
    value: (function () {
      var _addAllToCart = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee9() {
        var _this9 = this;
        var items, _iterator0, _step0, _loop2, handle, _productData3, productData, variant, sellingPlan, item, response, error, result, productsForGTM, addToCartEvent, checkoutMode, cartOpenEvent, _t6, _t7;
        return _regenerator().w(function (_context1) {
          while (1) switch (_context1.n) {
            case 0:
              if (!this.isLoading) {
                _context1.n = 1;
                break;
              }
              return _context1.a(2);
            case 1:
              this.isLoading = true;
              _context1.p = 2;
              // Prepare cart items with selling plans
              items = []; // 1. Add products from new-product-section (only non-deleted ones)
              _iterator0 = _createForOfIteratorHelper(this.products);
              _context1.p = 3;
              _loop2 = /*#__PURE__*/_regenerator().m(function _loop2() {
                var product, productData, variant, sellingPlan, item;
                return _regenerator().w(function (_context0) {
                  while (1) switch (_context0.n) {
                    case 0:
                      product = _step0.value;
                      productData = _this9.productData.get(product.handle);
                      if (productData) {
                        _context0.n = 1;
                        break;
                      }
                      return _context0.a(2, 1);
                    case 1:
                      // Find variant by SKU, fallback to first variant
                      variant = productData.variants.find(function (v) {
                        return v.sku === product.sku;
                      }) || productData.variants[0];
                      sellingPlan = _this9.getSellingPlanData(productData);
                      item = {
                        id: variant.id,
                        quantity: product.quantity
                      }; // Add selling plan if available
                      if (sellingPlan && sellingPlan.id) {
                        item.selling_plan = sellingPlan.id;
                      }
                      items.push(item);
                    case 2:
                      return _context0.a(2);
                  }
                }, _loop2);
              });
              _iterator0.s();
            case 4:
              if ((_step0 = _iterator0.n()).done) {
                _context1.n = 7;
                break;
              }
              return _context1.d(_regeneratorValues(_loop2()), 5);
            case 5:
              if (!_context1.v) {
                _context1.n = 6;
                break;
              }
              return _context1.a(3, 6);
            case 6:
              _context1.n = 4;
              break;
            case 7:
              _context1.n = 9;
              break;
            case 8:
              _context1.p = 8;
              _t6 = _context1.v;
              _iterator0.e(_t6);
            case 9:
              _context1.p = 9;
              _iterator0.f();
              return _context1.f(9);
            case 10:
              if (!this.recommendationProduct) {
                _context1.n = 13;
                break;
              }
              handle = this.recommendationProduct.handle; // Fetch product data if not cached
              if (this.productData.has(handle)) {
                _context1.n = 12;
                break;
              }
              _context1.n = 11;
              return this.fetchProductData(handle);
            case 11:
              _productData3 = _context1.v;
              if (_productData3) {
                this.productData.set(handle, _productData3);
              }
            case 12:
              productData = this.productData.get(handle);
              if (productData) {
                variant = productData.variants[0];
                sellingPlan = this.getSellingPlanData(productData);
                item = {
                  id: variant.id,
                  quantity: this.recommendationProduct.quantity
                }; // Add selling plan if available
                if (sellingPlan && sellingPlan.id) {
                  item.selling_plan = sellingPlan.id;
                }
                items.push(item);
                console.log('Added recommendation product:', handle);
              }
            case 13:
              if (!(items.length === 0)) {
                _context1.n = 14;
                break;
              }
              alert('Bitte wählen Sie mindestens ein Produkt aus.');
              this.isLoading = false;
              return _context1.a(2);
            case 14:
              console.log('Cart items to add:', items);

              // Add all items to cart using Shopify Cart API
              _context1.n = 15;
              return fetch('/cart/add.js', {
                method: 'POST',
                headers: {
                  'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                  items: items
                })
              });
            case 15:
              response = _context1.v;
              if (response.ok) {
                _context1.n = 17;
                break;
              }
              _context1.n = 16;
              return response.json();
            case 16:
              error = _context1.v;
              throw new Error(error.description || 'Failed to add to cart');
            case 17:
              _context1.n = 18;
              return response.json();
            case 18:
              result = _context1.v;
              console.log('Added to cart:', result);

              // Collect all products info for single GTM event
              productsForGTM = items.map(function (item) {
                var _Array$from$find;
                var productHandle = ((_Array$from$find = Array.from(_this9.productData.entries()).find(function (_ref2) {
                  var _ref3 = _slicedToArray(_ref2, 2),
                    _ = _ref3[0],
                    data = _ref3[1];
                  return data.variants.some(function (v) {
                    return v.id === item.id;
                  });
                })) === null || _Array$from$find === void 0 ? void 0 : _Array$from$find[0]) || '';
                return {
                  product_sku: productHandle || item.id,
                  monthly_quantity: item.quantity
                };
              }); // Dispatch single GTM event with all products
              addToCartEvent = {
                event: 'quiz_add_to_cart',
                products: productsForGTM,
                products_count: productsForGTM.length,
                product_skus: productsForGTM.map(function (p) {
                  return p.product_sku;
                }),
                currency: 'EUR'
              };
              window.dataLayer = window.dataLayer || [];
              window.dataLayer.push(addToCartEvent);
              checkoutMode = this.getCheckoutMode();
              if (!(checkoutMode === 'checkout')) {
                _context1.n = 19;
                break;
              }
              this.trackCheckoutStart();
              window.location.href = this.buildCheckoutUrlWithDiscount();
              return _context1.a(2);
            case 19:
              // Track cart drawer open
              cartOpenEvent = {
                event: 'quiz_cart_open',
                checkout_type: 'quiz'
              };
              window.dataLayer = window.dataLayer || [];
              window.dataLayer.push(cartOpenEvent);

              // Dispatch ajaxProduct:added event to trigger cart drawer update and open
              document.dispatchEvent(new CustomEvent('ajaxProduct:added', {
                detail: {
                  product: result,
                  addToCartBtn: null
                }
              }));

              // Mobile-compatible cart drawer opening strategy:
              // 1. Try dispatching cart:open event
              // 2. If that doesn't work, directly click the cart trigger button
              // 3. If that doesn't work, directly manipulate the drawer DOM
              document.dispatchEvent(new Event('cart:open'));

              // Additional fallback for mobile Safari/Chrome where events may not trigger drawer
              setTimeout(function () {
                var cartDrawer = document.querySelector('#HeaderCart, .site-header__cart');
                var isDrawerOpen = cartDrawer && cartDrawer.classList.contains('is-active');
                if (!isDrawerOpen) {
                  console.log('Cart drawer not open via event, trying direct trigger click');
                  // Try clicking the cart trigger button directly
                  var cartTrigger = document.querySelector('#HeaderCartTrigger, .js-drawer-open-cart, [data-cart-trigger]');
                  if (cartTrigger) {
                    // Use both click and touchend for maximum mobile compatibility
                    try {
                      cartTrigger.click();
                    } catch (e) {
                      console.log('Click failed, trying manual open');
                    }
                  }

                  // Last resort: directly manipulate drawer classes
                  setTimeout(function () {
                    var drawer = document.querySelector('#HeaderCart');
                    var stillNotOpen = drawer && !drawer.classList.contains('is-active');
                    if (stillNotOpen) {
                      console.log('Direct trigger click failed, forcing drawer open via DOM');
                      drawer.classList.add('is-active');
                      document.documentElement.classList.add('cart-open');
                      var overlay = document.querySelector('.cart-overlay');
                      if (overlay) overlay.style.display = 'block';
                      document.body.style.overflow = 'hidden';
                    }
                  }, 50);
                }
              }, 50);
              _context1.n = 21;
              break;
            case 20:
              _context1.p = 20;
              _t7 = _context1.v;
              console.error('Error adding to cart:', _t7);
              alert('Fehler beim Hinzufügen zum Warenkorb. Bitte versuchen Sie es erneut.');
            case 21:
              _context1.p = 21;
              this.isLoading = false;
              return _context1.f(21);
            case 22:
              return _context1.a(2);
          }
        }, _callee9, this, [[3, 8, 9, 10], [2, 20, 21, 22]]);
      }));
      function addAllToCart() {
        return _addAllToCart.apply(this, arguments);
      }
      return addAllToCart;
    }()
    /**
     * Reset component state for quiz restart
     * Re-subscribes to quiz:calculationsComplete event
     */
    )
  }, {
    key: "reset",
    value: function reset() {
      var _this0 = this;
      // Reset all flags
      this.initialized = false;
      this.isLoading = false;
      this.listenersSetup = false;
      this._initPromise = null;

      // Clear products data
      this.products = [];
      this.productData.clear();
      this.recommendationProduct = null;

      // Clear container content
      var container = this.querySelector('.new-product-section__box-content');
      if (container) {
        container.innerHTML = '';
      }

      // Remove old event listener if exists
      if (this.quizCompleteHandler) {
        document.removeEventListener('quiz:calculationsComplete', this.quizCompleteHandler);
      }

      // Create new bound handler
      this.quizCompleteHandler = function () {
        _this0.init()["catch"](function (err) {
          return console.error('init error:', err);
        });
      };

      // Re-subscribe to event
      document.addEventListener('quiz:calculationsComplete', this.quizCompleteHandler);
    }
  }]);
}(/*#__PURE__*/_wrapNativeSuper(HTMLElement)); // Register custom element
if (!customElements.get('new-product-section')) {
  customElements.define('new-product-section', NewProductSection);
}


/***/ })

},
/******/ __webpack_require__ => { // webpackRuntimeModules
/******/ var __webpack_exec__ = (moduleId) => (__webpack_require__(__webpack_require__.s = moduleId))
/******/ var __webpack_exports__ = (__webpack_exec__("./src/assets/js/quiz-components-v2/new-product-section.js"));
/******/ }
]);